import React from "react"
import Backend from "./Backend"

const safeParseSessionStorageData = (keyName, fallbackReturnData = null) => {
  try {
    return JSON.parse(sessionStorage.getItem(keyName)) || fallbackReturnData
  } catch (_) {
    return fallbackReturnData
  }
}
export default class Currency {

  static currencyObject = safeParseSessionStorageData("storefrontCurrencyObject", {})

  static symbolFormat(value, symbol) {
    let dollarValue = parseFloat(value)
    return symbol + dollarValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  }

  static format(value, currencyCode="eur") {
    let dollarValue = parseFloat(value)
  	let symbol = Currency.getSymbol(currencyCode)
    let price = symbol + dollarValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return price.replace(".00", "")
  }

  static getSymbol(currencyCode){
    switch (currencyCode.toLowerCase()) {
      case 'eur': return '€'
      case 'gbp': return '£'
      case 'usd':
      case 'cad': return '$'
      default:    return '€'
    }
  }

  static getCampaignConfiguration(currencyCode){
    const searchCurrencyCode = (currencyCode || window?.CURRENT_CAMPAIGN?.currency || "USD").toLowerCase()
    const currencyObj = window?.CURRENT_CAMPAIGN?.currencies?.find((o) => {
      return o.currencyCode?.toLowerCase() === searchCurrencyCode
    })
    return currencyObj
  }

  static async setCurrencyObject(currencyCode){
    const campaignCurrency = window.CURRENT_CAMPAIGN?.currency
    const currencyObject = Currency.getCampaignConfiguration(currencyCode || campaignCurrency) || {}
    sessionStorage.setItem("storefrontCurrencyObject", JSON.stringify(currencyObject))
    Currency.currencyObject = currencyObject
    if (currencyObject.currencyCode && campaignCurrency && currencyObject.currencyCode !== campaignCurrency) {
      try {
        const exchangeRate = await Backend.getCurrencyExchangeRate(campaignCurrency, currencyCode)
        exchangeRate ? sessionStorage.setItem("storefrontClientExchangeRate", exchangeRate) : sessionStorage.removeItem("storefrontClientExchangeRate")
      } catch (_) {
        sessionStorage.removeItem("storefrontClientExchangeRate", 1)
        const currencyObject = Currency.getCampaignConfiguration(campaignCurrency) || {}
        sessionStorage.setItem("storefrontCurrencyObject", JSON.stringify(currencyObject))
      }
    } else {
      sessionStorage.setItem("storefrontClientExchangeRate", 1)
    }
  }

  static toConvert(price) {
    const { currencyFee, decimals, rounding } = Currency.currencyObject
    const exchangeRate = Number(sessionStorage.getItem("storefrontClientExchangeRate")) || 1
    let itemTotalPrice = price * exchangeRate
    if (currencyFee) {
      itemTotalPrice = itemTotalPrice * (1 + (currencyFee / 100))
    }
    if ((decimals === 0 || decimals) && rounding && itemTotalPrice) {
      const price = itemTotalPrice.toString().split(".")
      if (rounding === 1) {
        itemTotalPrice = price[1] && Number(price[1]) ? (Number(price[0]) + 1).toString() : itemTotalPrice
      } else if (price[1] && Number(price[1]) > Number(rounding)) {
        itemTotalPrice = (Number(price[0]) + 1).toString() + "." + rounding
      } else {
        itemTotalPrice = price[0] + "." + rounding
      }
    }
    return parseFloat(itemTotalPrice)
  }

  static toFormat(price, useValueDecimalCount) {
    const { decimals, isComma, symbolAlign, currencySymbol = window.CURRENT_CAMPAIGN?.currencySymbol || "" } = Currency.currencyObject
    let itemTotalPrice = Currency.toConvert(price)
    itemTotalPrice = (itemTotalPrice && itemTotalPrice.toString()) || "0"
    if (itemTotalPrice) {
      const splitValues = itemTotalPrice.split(".")
      const decimalValue = useValueDecimalCount ? (splitValues[1] ? splitValues[1].length : 0) : (decimals === 0 || decimals ? decimals : 2)
      if (decimalValue == 0 || decimalValue) {
        itemTotalPrice = decimalValue === 0 ? splitValues[0] : splitValues[0] + "." + ((splitValues[1] || "00") + "0000000000").substring(0, decimalValue)
      }
      if (isComma) {
        itemTotalPrice = itemTotalPrice.replace(".", ",")
      }
      switch (symbolAlign?.toUpperCase()) {
        case "RIGHT":
          itemTotalPrice = itemTotalPrice + currencySymbol
          break
        case "RIGHT_SPACE":
          itemTotalPrice = <>{itemTotalPrice}&nbsp;{currencySymbol}</>
          break
        case "LEFT_SPACE":
          itemTotalPrice = <>{currencySymbol}&nbsp;{itemTotalPrice}</>
          break
        default:
          itemTotalPrice = currencySymbol + itemTotalPrice
      }
    }
    return itemTotalPrice
  }
}
